import React from 'react';
import PropTypes from 'prop-types';

import {Image, Box, Skeleton} from 'views/components';

const ImageDisplay = (props) => {
  const [src, setSrc] = React.useState(null);

  const getDownloadedSrc = props.getDownloadedSrc;
  const sx = props.sx;

  React.useEffect(() => {
    const updateSrc = async () => {
      const imgSrc = await getDownloadedSrc();
      if (imgSrc) setSrc(imgSrc);
    };

    updateSrc();
  }, [getDownloadedSrc]);

  const openImage = () => {
    window.open(src);
  };

  if (src) {
    return (
      <Box
        onClick={openImage}
        height={'100%'}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 'inherit',
          ...sx,
        }}
      >
        <Image
          sx={{
            maxHeight: '100%',
            maxWidth: 'inherit',
            objectFit: 'contain',
          }}
          src={src}
        />
      </Box>
    );
  } else {
    return (
      <Skeleton
        variant='rectangular'
        width={450}
        height={300}
      />
    );
  }
};

ImageDisplay.propTypes = {
  getDownloadedSrc: PropTypes.func.isRequired,
  sx: PropTypes.object,
};

export default ImageDisplay;
